




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CardInputSKNapza from "@/components/pemeriksaan/resumeSuketV2/CardInputSKNapza.vue";
import moment from "moment";
import BaseCardSuket from "./BaseCardSuket.vue";
import { SuketBebasNapzaInterface } from "@/types/suket_bebas_napza";
import StoreSuketBebasNapza from "@/store/modules/SuketBebasNapza";
import SuketBebasNapza from "@/services/SuketBebasNapza";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    CardModalTtd,
    CardInputSKNapza,
    BaseCardSuket
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CardSKNapza extends Vue {
  @Prop() readonly register!: string;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["13", "2E", "2Q"];
  modalTtd = false;

  get dataSuket(): SuketBebasNapzaInterface {
    return StoreSuketBebasNapza.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.created_at).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketBebasNapza.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.dokter_id;
  }

  get signeeUserId() {
    return this.dataSuket?.dokter_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return !this.allowedUnit.includes(userModule.user.unit_id);
    // return false;
  }

  get pemeriksaanUrin() {
    return this.dataSuket.pemeriksaan_urin &&
      this.dataSuket.pemeriksaan_urin.length
      ? this.dataSuket.pemeriksaan_urin
          .map(item => {
            return item.name;
          })
          .join(", ")
      : "-";
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketBebasNapza.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    // console.log(value);
    SuketBebasNapza.sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
          appModule.addMsgTtd("");
          StoreSuketBebasNapza.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  hapusSuket() {
    SuketBebasNapza.destroy(this.dataSuket.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Hapus Surat Bebas Napza");
          StoreSuketBebasNapza.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
      });
  }
}
